<template>
  <maker-layout>
    <div>
      <domains-list :maker="maker" :admin="canUpdateDomains">
        <template slot="beforeList" v-if="!canUpdateDomains">
          <v-alert dense text outlined type="info" class="text-left">
            Ce prestataire gère lui-même ces informations
          </v-alert>
        </template>
      </domains-list>
    </div>
  </maker-layout>
</template>

<script>
import { mapState } from 'vuex';
import MakerLayout from '@/views/settings/makers/MakerLayout.vue';
import DomainsList from '@/views/settings/DomainsList.vue';

export default {
  data: () => ({
  }),
  computed: {
    ...mapState(`ui/settingsMakers`, {
      maker: `currentAdminMaker`,
    }),
    canUpdateDomains() {
      return this.maker?.slug === ``;
    },
  },
  components: {
    MakerLayout,
    DomainsList,
  },
};
</script>
